import React from 'react';
import PropTypes from 'prop-types';
import gettext from '@eb/gettext';

import './LegalNotice.scss';

export default class LegalNotice extends React.PureComponent {
    static propTypes = {
        locale: PropTypes.string,
        hideLegalNotice: PropTypes.bool,
    };

    render() {
        const { hideLegalNotice } = this.props;

        if (hideLegalNotice) {
            return null;
        }

        const copy = gettext(
            'By clicking "Sign Up" I accept the Eventbrite <a href="/tos" target="_blank" rel="noopener noreferrer">terms of service</a>, <a href="/community-guidelines" target="_blank" rel="noopener noreferrer">community guidelines</a> and have read the <a href="/privacypolicy" target="_blank" rel="noopener noreferrer">privacy policy</a>.',
        );

        return (
            <div className="privacy-terms eds-l-mar-top-5 eds-l-mar-bot-4">
                <aside
                    className="eds-text-bs eds-text--center"
                    // Needed for links to work in gettext; no user-generated content
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: copy,
                    }}
                />
            </div>
        );
    }
}
